import React from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import ButtonWrapper from "../../components/Button";
import FileUploader from "../../../TCPForms/formComponents/MobileTowerApplication/FileUploader";

const Step3 = ({ formData, handleTabChange }) => {
    const { documents } = useSelector(state => state.formMT);
    const defaultValues = {
        ...formData,
        documents,
    }
    const isApprovedLayout = formData?.approvedLayout === 'yes'
    const { handleSubmit, control, setValue } = useForm({ defaultValues });

    useEffect(() => {
        setValue('documents', documents)
    }, [documents]);

    const onSubmit = (data) => {
        handleTabChange(3, data)
    }
    return (
        <section className="groupContainer">
            <form onSubmit={handleSubmit(onSubmit)}>
                {isApprovedLayout && <div className="formContainer">
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">Upload Documents</h2>
                    </div>
                    <div className="formInputContainer">
                        <div className="columnWrapper">
                            <FileUploader
                                isMandatory
                                label="Allotment Letter"
                                control={control}
                                name="Allotment Letter"
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                                required
                            />
                            <FileUploader
                                label="Possession letter"
                                control={control}
                                name="Possession letter"
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                            />
                            <FileUploader
                                label="Registry"
                                control={control}
                                name="Registry"
                                isMandatory
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                                required
                            />
                        </div>
                        <div className="columnWrapper">
                            <FileUploader
                                label="Mutation Letter"
                                control={control}
                                name="Mutation Letter"
                                isMandatory
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                                required
                            />
                            <FileUploader
                                label="HPTA(Hire Purchase and Agreements)"
                                control={control}
                                name="HPTA(Hire Purchase and Agreements)"
                                isMandatory
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                                required
                            />
                            <FileUploader
                                label="Up to date payment Certificate"
                                control={control}
                                name="Up to date payment Certificate"
                                isMandatory
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                                required

                            />
                        </div>
                    </div>
                </div>}
                {!isApprovedLayout && <div className="formContainer">
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">Supporting Documents</h2>
                    </div>
                    <div className="formInputContainer">
                        <div className="columnWrapper">
                            <FileUploader
                                label="Agreement"
                                control={control}
                                name="Agreement"
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                            />
                            <FileUploader
                                label="Site Plan"
                                control={control}
                                name="Site Plan"
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                            />
                        </div>
                        <div className="columnWrapper">
                            <FileUploader
                                label="NOC from Land Acquisition Dept"
                                control={control}
                                name="NOC from Land Acquisition Dept"
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                            />
                            <FileUploader
                                label="Documents related to Khata No. and Khasara No. "
                                control={control}
                                name="Documents related to Khata No. and Khasara No. "
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                            />
                        </div>
                    </div>
                </div>}

                <div className="footerContainer">
                    <div className="buttonWrapper">
                        <ButtonWrapper
                            variant="contained"
                            color="error"
                            size="medium"
                            label="Prev"
                            sx={{ backgroundColor: '#CCC' }}
                            onClick={() => handleTabChange(1)}
                        />
                        <ButtonWrapper
                            variant="contained"
                            color="success"
                            size="medium"
                            label="Save"
                            type="submit"
                            sx={{ backgroundColor: '#157CB3' }}
                        />
                    </div>
                </div>
            </form>
        </section>
    );
};

export default Step3;
